export default __webpack_public_path__ + "static/media/defaultLogo.812d45ed.png";